export default function ($scope) {
    const $carousel = $('.ob-image-main-carousel:not(.slick-initialized)', $scope);
    const $thumbs = $('.ob-thumb-nav .nav-image', $scope);
    const $thumbsContainer = $('.ob-thumb-nav:not(.slick-initialized)', $scope);

    if ($carousel.length > 0) {
        const thumbCount = $thumbs.length;

        $carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 150,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            swipeToSlide: true,
            useTransform: false,
        });

        $thumbsContainer.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            speed: 150,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            swipeToSlide: true,
            useTransform: false,
            asNavFor: ".ob-image-main-carousel",
            focusOnSelect: true,
            vertical: false,
            responsive: [
                {
                    breakpoint: 801,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                        vertical: true
                    }
                },
                {
                    breakpoint: 1261,
                    settings: {
                        slidesToShow: 5,
                        arrows: true,
                        vertical: true
                    }
                }
            ]
        });

        let activeIndex = 0;

         $carousel.on('afterChange', function(event, slick, currentSlide) {

            if (currentSlide === activeIndex) return;

            activeIndex = currentSlide;

            const $thumbSlick = $thumbsContainer.slick('getSlick');
            const slidesToShow = $thumbSlick.options.slidesToShow;
            const currentThumbSlide = $thumbSlick.currentSlide;
            
            // Remove active class from all thumbs
            $thumbs.removeClass('slick-current');
            // Add active class to current thumb
            $thumbs.eq(currentSlide).addClass('slick-current');
            
            // Only scroll if there are more thumbs than can be displayed
            if (thumbCount > slidesToShow) {
                // Scroll thumb carousel forward if current slide is beyond visible area
                if (currentSlide >= currentThumbSlide + slidesToShow) {
                    $thumbsContainer.slick('slickGoTo', currentSlide);
                }
                // Scroll thumb carousel backward if current slide is before the visible area
                else if (currentSlide < currentThumbSlide) {
                    $thumbsContainer.slick('slickGoTo', currentSlide);
                }
            }
        });
    }
}
